import PropTypes from 'prop-types';
import React from 'react';
import './Rating.scss';

const wingWidth = {
    small: 60,
    medium: 115,
    large: 220,
    default: 75,
};
export default class Rating extends React.Component {
    getRatingWidth = () => {
        const { totalRating, rating, size } = this.props;
        return (Number(rating) / totalRating) * wingWidth[size];
    };

    render() {
        const { size } = this.props;
        return (
            <div className="rating">
                {this.props.rating && (
                    <div className={`rating-wings ${size}`}>
                        <div className="wing-bg" />
                        <div
                            className="wing"
                            style={{ width: `${this.getRatingWidth()}px` }}
                        />
                        {this.props.showNumber ? (
                            <div className="number">
                                {Number(this.props?.rating).toFixed(1)}
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        );
    }
}

Rating.propTypes = {
    /**
     * rating number
     */
    rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * size of icon
     */
    size: PropTypes.string,
    /**
     * whether or not to show number
     */
    showNumber: PropTypes.bool,
    // eslint-disable-next-line react/no-unused-prop-types
    totalWidth: PropTypes.number,
    totalRating: PropTypes.number,
};

Rating.defaultProps = {
    totalRating: 5,
    totalWidth: 5 * 15,
    size: 'default',
    showNumber: true,
    rating: null,
};
